import React from 'react';
import apiclient from 'lib/apiclient';
import { query } from 'js-query-builder';

function getThisMonth()
{
  const today = new Date();
  return {year:today.getFullYear(), month:today.getMonth()+1};
}

function getLastMonth()
{
  return getPrevMonth(getThisMonth());
}

function getNextMonth(value)
{
  if (value.month === 12) {
    return {year:value.year + 1, month:1};
  }
  else {
    return {year:value.year, month:value.month + 1}
  }
}

function getPrevMonth(value)
{
  if (value.month === 1) {
    return {year:value.year - 1, month:12};
  }
  else {
    return {year:value.year, month:value.month - 1}
  }
}

const Table = (data) => {
  return (
    <React.Fragment>
      <h2>{data.customerId}</h2>
      <table className='table table-striped' aria-labelledby="tabelLabel">
        <thead>
          <tr>
            <th>名称</th>
            <th>回数</th>
          </tr>
        </thead>
        <tbody>
          {(data.items) ? data.items.map(item =>
            <tr key={item.name}>
              <td>{item.name}</td>
              <td>{item.count}</td>
            </tr>
          ): null}
        </tbody>
      </table>
    </React.Fragment>
  );
}

export default (props) => {
  const [data, setData] = React.useState({});

  const month = props.match && props.match.params && props.match.params.month;
  const id = props.match && props.match.params && props.match.params.id;

  
  React.useEffect(() => {
    setData({ loaded: false });
    apiclient.get(
      query(`api/sales/${month}/${id}`)
        .build())
      .then(response => {
        setData({ list: response.data, loaded: true });
          });
  }, [month, id]);

  const contents = data.loaded ? Table(data.list) : <p><em>Loading...</em></p>;

    return (
      <div>
        <h1 id="tabelLabel" >売上詳細</h1>
       {contents}
      </div>
    );
}